import { render } from "./AssetManagerModal.vue?vue&type=template&id=65d3c928"
import script from "./AssetManagerModal.vue?vue&type=script&lang=js"
export * from "./AssetManagerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__